import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SidebarContextType {
  mainSidebarCollapsed: boolean;
  setMainSidebarCollapsed: (collapsed: boolean) => void;
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export const SidebarProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [mainSidebarCollapsed, setMainSidebarCollapsed] = useState(false);

  return (
    <SidebarContext.Provider value={{ mainSidebarCollapsed, setMainSidebarCollapsed }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (context === undefined) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
};
